import { Arc, Line } from "./NodeDXF";
import { debug, isObject, TYPE_FOLD, TYPE_CUT } from "./nodedxf2";
import { Contour } from "./DrawingObj";
export var DXFSpace;
(function (DXFSpace) {
    class DXFOBJECT extends Object {
        constructor(named, retry = false, CreatedLine) {
            super();
            this.CreatedLine = 0; //this is the app line number in the DXF file that this obejct was created from
            this.Objects = [];
            this.Drawables = [];
            this.NAME = ""; //??
            this.Visible = true;
            this.named = named;
            this.retry = retry;
            this.CreatedLine = CreatedLine;
        }
        setVar(name, value, code = "unknown") {
            if (name == null)
                console.error("setVar name is null", this.named, value, code);
            if (!this.VARS)
                this.VARS = {};
            this.VARS[name] = value;
        }
        getVar(name) {
            return this.VARS ? this.VARS[name] : null;
        }
        setX(code, name, value) {
            if (!name) {
                debug("SetX No Name");
                return;
            }
            var v = this.getVar(name);
            if (!v)
                v = {};
            if (!isObject(v)) {
                console.error("SetX Not Obect", name, v);
                return;
            }
            if (!v[code])
                v[code] = [];
            v[code].push(value);
            this.setVar(name, v, "setX" + code);
        }
        setY(code, name, value) {
            if (!name) {
                debug("setY No Name");
                return;
            }
            var v = this.getVar(name);
            if (!v)
                v = {};
            if (!isObject(v)) {
                console.error("SetY Not Obect", name, v);
                return;
            }
            if (!v[code])
                v[code] = [];
            v[code].push(value);
            this.setVar(name, v, "setY" + code);
        }
        setZ(code, name, value) {
            if (!name) {
                debug("setZ No Name");
                return;
            }
            var v = this.getVar(name);
            if (!v)
                v = {};
            if (!isObject(v)) {
                console.error("SetZ Not Obect", name, v);
                return;
            }
            if (!v[code])
                v[code] = [];
            v[code].push(value);
            this.setVar(name, v, "setZ" + code);
        }
        addSubClass(c) {
            //todo relook at this
            if (c.named && !this[c.named]) {
                this[c.named] = c;
                return;
            }
            if (!this.SubClasses)
                this.SubClasses = [];
            this.SubClasses.push(c);
        }
        addObject(c) {
            if (!this.Objects)
                this.Objects = [];
            this.Objects.push(c);
        }
        //this is run post read to create all the drables
        cleanup(parent = null) {
            if (!this.Objects)
                return;
            parent = !parent ? this : parent;
            this.Objects.forEach((element) => {
                if (element.NAME &&
                    !this[element.NAME] &&
                    element.NAME !== "OBJECTS") {
                    this[element.NAME] = element;
                }
            });
            if (this.drawSection())
                this.Objects.map((element) => {
                    element.cleanup(parent);
                    if (element.named) {
                        let a = null;
                        switch (element.named) {
                            case "LINE":
                                a = new Line(element);
                                break;
                            case "LWPOLYLINE":
                                a = new Line(element);
                                break;
                            case "POLYLINE":
                                a = new Line(element);
                                break;
                            case "CIRCLE":
                                a = new Arc(element);
                                break;
                            case "ARC":
                                a = new Arc(element);
                                break;
                            // default:
                            //     debug(element)
                        }
                        if (a)
                            parent.Drawables.push(a);
                    }
                });
        }
        calcContour(contour = null) {
            if (!contour)
                contour = new Contour();
            if (this.Drawables)
                this.Drawables.reduce((total, element, i) => {
                    if (["LINE", "POLYGON", "CIRCLE", "ARC"].includes(element.named)) {
                        let minx = element.minX(total.min.x);
                        if (Number.isNaN(minx)) {
                            this.addError('Error in line length, line #:' + i.toString());
                        }
                        total.min.x = minx;
                        total.min.y = element.minY(total.min.y);
                        total.max.x = element.maxX(total.max.x);
                        total.max.y = element.maxY(total.max.y);
                        contour.height = contour.max.y - contour.min.y;
                        contour.width = contour.max.x - contour.min.x;
                        switch (element.Type) {
                            case TYPE_CUT:
                                contour.Cuts.qty = contour.Cuts.qty + 1;
                                contour.Cuts.totallen = contour.Cuts.totallen + element.length();
                                // console.log(c);
                                break;
                            case TYPE_FOLD:
                                contour.Bends.qty = contour.Bends.qty + 1;
                                contour.Bends.totallen = contour.Bends.totallen + element.length();
                        }
                    }
                    if (Number.isNaN(total.min.x)) {
                        console.log('Error in element', total, element);
                    }
                    return total;
                }, contour);
            return contour;
        }
        // updateObjects(id, type, Objects) {
        //     if (!Objects)
        //         return false;
        //     return Objects.forEach(o => {
        //         if (o.id && o.id === id) {
        //             o.setType(type);
        //         }
        //         else
        //             this.updateObjects(id, type, o.Objects);
        //     });
        // }
        // setTypes(ids, Type) {
        //     ids.forEach(id => this.updateObjects(id, Type, this.Objects));
        //     this.updateBends();
        // }
        updateBends() {
            this.bends = this.Drawables.filter((v) => v.Type == TYPE_FOLD).map((v, i) => {
                return { id: v.id, index: i, value: null };
            });
            this.bends && (this.bends = this.bends.flat().filter((v) => v));
            debug("Bends Updated: ", this.bends);
            return this.bends;
        }
        drawSection() {
            if (this.named != "SECTION")
                return true;
            // //not sure what/why this is doign
            //  return true;
            if (this.retry)
                return true;
            return Object.keys(this).indexOf("ENTITIES") < 0;
        }
        last() {
            return this.Objects[this.Objects.length - 1];
        }
        addError(error) {
            if (!this.errors)
                this.errors = [];
            this.errors.push(error);
        }
    }
    DXFSpace.DXFOBJECT = DXFOBJECT;
    class CIRCLE extends DXFOBJECT {
        constructor() {
            super(...arguments);
            this.StartAngle = 0;
            this.EndAngle = Math.PI * 2; //angles are in radians
        }
    }
    DXFSpace.CIRCLE = CIRCLE;
    class LINE extends DXFOBJECT {
    }
    DXFSpace.LINE = LINE;
    class ARC extends DXFOBJECT {
    }
    DXFSpace.ARC = ARC;
    class BLOCK_RECORD extends DXFOBJECT {
    }
    DXFSpace.BLOCK_RECORD = BLOCK_RECORD;
    class SECTION extends DXFOBJECT {
    }
    DXFSpace.SECTION = SECTION;
    class VISUALSTYLE extends DXFOBJECT {
    }
    DXFSpace.VISUALSTYLE = VISUALSTYLE;
    class CLASS extends DXFOBJECT {
    }
    DXFSpace.CLASS = CLASS;
    class LAYER extends DXFOBJECT {
    }
    DXFSpace.LAYER = LAYER;
    class LTYPE extends DXFOBJECT {
    }
    DXFSpace.LTYPE = LTYPE;
    class VPORT extends DXFOBJECT {
    }
    DXFSpace.VPORT = VPORT;
    class BLOCK extends DXFOBJECT {
    }
    DXFSpace.BLOCK = BLOCK;
    class TABLE extends DXFOBJECT {
    }
    DXFSpace.TABLE = TABLE;
    class AcDbSymbolTable extends DXFOBJECT {
    }
    DXFSpace.AcDbSymbolTable = AcDbSymbolTable;
    class AcDbBlockBegin extends DXFOBJECT {
    }
    DXFSpace.AcDbBlockBegin = AcDbBlockBegin;
    class AcDbBlockEnd extends DXFOBJECT {
    }
    DXFSpace.AcDbBlockEnd = AcDbBlockEnd;
    class AcDbEntity extends DXFOBJECT {
    }
    DXFSpace.AcDbEntity = AcDbEntity;
    class AcDbViewportTableRecord extends DXFOBJECT {
    }
    DXFSpace.AcDbViewportTableRecord = AcDbViewportTableRecord;
    DXFSpace.classes = {
        CIRCLE,
        LINE,
        ARC,
        BLOCK_RECORD,
        SECTION,
        VISUALSTYLE,
        CLASS,
        LAYER,
        LTYPE,
        VPORT,
        BLOCK,
        TABLE,
        AcDbBlockBegin,
        AcDbBlockEnd,
        AcDbEntity,
        AcDbSymbolTable,
        AcDbViewportTableRecord,
    };
})(DXFSpace || (DXFSpace = {}));
export let CreateDXFObject = (named, retry = false, CreatedLine) => {
    let checkClass = named.trim().replace(/[*&^]/g, '');
    if (DXFSpace.hasOwnProperty(checkClass)) {
        return new DXFSpace.classes[checkClass](named, retry, CreatedLine);
    }
    return new DXFSpace.DXFOBJECT(named, retry, CreatedLine);
};
